<script>
export default {
  name: 'FundraiserRaisedAmount',
  props: {
    fundraiser: {
      type: Object,
      required: true
    }
  },
  computed: {

  }
}
</script>

<template>
  <div class="flex flex-wrap gap-2 justify-between items-end mb-2">
    <h2 class="text-2xl lg:text-3xl font-medium">
      ${{ fundraiser.cached.raised_formatted }}
    </h2>
    <span v-if="fundraiser.settings?.goal_hidden !== true" class="text-sm font-sans font-medium mb-[2px]">
      {{ fundraiser.cached.percentage_raised }}% of ${{ fundraiser.goal_formatted }} goal
    </span>
  </div>
</template>

<style scoped>

</style>
